import { CustomComponentProps } from "utils/types/generalTypes";
import SVG from "../core/SVG";

export type FormGifViewerProps = CustomComponentProps & {
    gif: string;
    handleRemoveMedia: () => void;
};

const FormGifViewer = ({
    gif,
    handleRemoveMedia,
    className,
    style
}: FormGifViewerProps) => {
    return (
        <div
            className={`gif-viewer post-media-displayer ${className}`}
            style={style}
        >
            <div className="d-flex flex-j-end">
                <div className="close-wrap">
                    <span
                        className="custom-close-modal"
                        onClick={handleRemoveMedia}
                    >
                        <SVG svg="x" size={16} />
                    </span>
                </div>
            </div>
            <div className="gif-viewer-container">
                <img src={gif} alt="" />
                {/* <div className="gifimage" data-gif={gif}></div> */}
            </div>
        </div>
    );
};

export default FormGifViewer;
